/* eslint-disable */

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {

    $('.cd-timeline-block').each(function () {
      $(this).find('.time__year').on('hover', function () {

        $(this).parent('.cd-timeline-block').toggleClass('timeline__hover');
      }) ;
      $(this).find('.cd-timeline-content').on('hover', function () {
        $(this).parent('.cd-timeline-block').toggleClass('timeline__hover');
      }) ;
    });

    $('.cd-timeline-block').each(function () {
      $(this).find('.time__year').on('click', function () {

        var parent =  $(this).parent('.cd-timeline-block');

        if(parent.hasClass('timeline__click')) {
          parent.removeClass('timeline__click');
        } else {
          parent.siblings().removeClass('timeline__click');
          parent.addClass('timeline__click');
        }
      }) ;

      $(this).find('.cd-timeline-content').on('click', function () {
        var parent =  $(this).parent('.cd-timeline-block');

        if(parent.hasClass('timeline__click')) {
          parent.removeClass('timeline__click');
        } else {
          parent.siblings().removeClass('timeline__click');
          parent.addClass('timeline__click');
        }
      });

    });

    $(document).ready(function(){
      var timelineBlocks = $('.cd-timeline-block'),
        offset = 0.8;

      //hide timeline blocks which are outside the viewport
      hideBlocks(timelineBlocks, offset);

      //on scolling, show/animate timeline blocks when enter the viewport
      $(window).on('scroll', function(){
        (!window.requestAnimationFrame)
          ? setTimeout(function(){ showBlocks(timelineBlocks, offset); }, 100)
          : window.requestAnimationFrame(function(){ showBlocks(timelineBlocks, offset); });
      });

      function hideBlocks(blocks, offset) {
        blocks.each(function(){
          ( $(this).offset().top > $(window).scrollTop()+$(window).height()*offset ) && $(this).find('.cd-timeline-img, .cd-timeline-content').addClass('is-hidden');
        });
      }

      function showBlocks(blocks, offset) {
        blocks.each(function(){
          ( $(this).offset().top <= $(window).scrollTop()+$(window).height()*offset && $(this).find('.cd-timeline-img').hasClass('is-hidden') ) && $(this).find('.cd-timeline-img, .cd-timeline-content').removeClass('is-hidden').addClass('bounce-in');
        });
      }
    });

    function checkUrl() {
      if (window.location.href.indexOf('page') > -1) {
        return true;
      }
    }

    $('.wrap-cat input[type=radio]').on('change', function() {
    var check = checkUrl();
    var baseUrl = window.location.href.split('/page')[0];
    var val = $(this).val();
    var name = $(this).attr('name');
    console.log(check);
    console.log(val)
    if (check === true) {
      window.location.href = baseUrl + '/?' + name + '=' + val;
    } else {
      $(this).closest('form').submit();
    }
   });

    // JavaScript to be fired on all pages, after page specific JS is fired
    var $hamburger = $('.hamburger');
    $hamburger.on('click', function () {
      $hamburger.toggleClass('is-active');
      $('html, body').toggleClass('no-scroll');
    });

    $(document).ready(function(){
      $('[data-toggle="tooltip"]').tooltip();
    });

    var acc = document.getElementsByClassName('accordion');
    var i;
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener('click', function() {
        /* Toggle between adding and removing the "active" class,
        to highlight the button that controls the panel */
        this.classList.toggle('active');

        /* Toggle between hiding and showing the active panel */
        var panel = this.nextElementSibling;
        if (panel.style.display === 'block') {
          panel.style.display = 'none';
        } else {
          panel.style.display = 'block';
        }
      });
    }

    $('#innovate-modal .accordion').first().click();
    $('#invest-modal .accordion').first().click();
    $('#engage-modal .accordion').first().click();
    $('#highlight-modal .accordion').first().click();

    /*
    $(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();

      $('html, body').animate({
        scrollTop: $($.attr(this, 'href')).offset().top,
      }, 1000);
    });

     */
/*
    $('.quotes-slider').owlCarousel({
      loop:true,
      nav:false,
      items:1,
      margin: 0,
      center:true,
      singleItem: true,
      autoplayHoverPause: true,
      autoplayTimeout:6000,
      autoplay: true,
      // autoHeight : true,
      animateOut: 'slideOutRight',
      autoplaySpeed: 1000,
    });

 */

    /*
    $('.slider-text').owlCarousel({
      loop:false,
      nav:false,
      items:1,
      margin: 50,
      center:true,
      singleItem: true,
      autoplayHoverPause: true,
      autoplayTimeout:6000,
      autoplay: false,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      autoplaySpeed: 1000,
      dots:false,
      stagePadding: 0,
    });

     */

    function CheckSafari() {
      var ua = navigator.userAgent.toLowerCase();
      var browserName;
      if (ua.indexOf('safari') != -1) {
        if (ua.indexOf('chrome') > -1) {
          browserName = 'chrome'
          $('header').addClass(browserName);
          $('.main').addClass(browserName);
        } else {
          browserName = 'safari'
          $('header').addClass(browserName);
          $('.main').addClass(browserName);
        }
      }
    }
    CheckSafari();

    var owl = $('.owl-carousel');
    owl.owlCarousel();

    $('.owl-point').click(function() {
      owl.trigger('next.owl.carousel');
    })

    $(document).ready(function (){
      $('#point-1').addClass('active');
    });

    $('#point-1').click(function() {
      $('#point-1').addClass('active');
      $('#point-2').removeClass('active');
      $('#point-3').removeClass('active');
    });

    $('#point-2').click(function() {
      $('#point-2').addClass('active');
      $('#point-1').removeClass('active');
      $('#point-3').removeClass('active');
    })

    $('#point-3').click(function() {
      $('#point-3').addClass('active');
      $('#point-1').removeClass('active');
      $('#point-2').removeClass('active');
    })

    $('.points').click(function(){
      var idpoint = $(this).attr('data-id');
      // console.log(idpoint);
      $('.items-slide').removeClass('active');
      $('#slide-' + idpoint ).addClass('active');
    });

      $('.points').click(function(){
          var idpoint = $(this).attr('data-id');
          // console.log(idpoint);
          $('.items-slidess').removeClass('active');
          $('#slidess-' + idpoint ).addClass('active');
      });


    $('.innovate-open-modal').click(function() {
      $('#innovate-modal').modal('toggle');
      $('.modal').addClass('innovate')
    })

    $('.invest-open-modal').click(function() {
      $('#invest-modal').modal('toggle');
      $('.modal').addClass('invest')
    })

    $('.engage-open-modal').click(function() {
      $('#engage-modal').modal('toggle');
      $('.modal').addClass('engage')
    })

    $('.highlight-open-modal').click(function() {
      $('#highlight-modal').modal('toggle');
      $('.modal').addClass('highlight')
    })

    $('.close-modal').click(function() {
      $('#impact-modal').modal('toggle');

      if ($('.modal').hasClass('engage')){
        $('.modal').removeClass('engage')
      } else if ($('.modal').hasClass('invest')) {
        $('.modal').removeClass('invest')
      } else if ($('.modal').hasClass('innovate')) {
        $('.modal').removeClass('innovate')
      }
    })

    $('#innovate-modal .nav-tabs a').click(function(){
      var datakey = $(this).attr('data-key');
      $('.modal-footer .nav-tabs a[href="#tab-inovate-footer-'+ datakey +'"]').click();
    });

    $('#invest-modal .nav-tabs a').click(function(){
      var datakey = $(this).attr('data-key');
      $('.modal-footer .nav-tabs a[href="#tab-invest-footer-'+ datakey +'"]').click();
    });

    $('#engage-modal .nav-tabs a').click(function(){
      var datakey = $(this).attr('data-key');
      $('.modal-footer .nav-tabs a[href="#tab-engage-footer-'+ datakey +'"]').click();
    });

    $('#highlight-modal .nav-tabs a').click(function(){
      var datakey = $(this).attr('data-key');
      $('.modal-footer .nav-tabs a[href="#tab-highlight-footer-'+ datakey +'"]').click();
    });

    /*
    $('.view-impact').click(function(){
      var key = $(this).attr('data-key');
      var scroll = $(window).scrollTop();
      $('#'+ key +'-modal').attr('data-scroll', scroll);

      $('body').css({
        'overflow' : 'hidden',
        'position' : 'fixed',
        'top' : -scroll,
      });

      console.log(scroll);
    });

    $('#innovate-modal').on('hidden.bs.modal', function () {
      $('body').css({
        'overflow' : 'initial',
        'position' : 'initial',
        'top' : 'initial',
      });
    })

    $('#engage-modal').on('hidden.bs.modal', function () {
      $('body').css({
        'overflow' : 'initial',
        'position' : 'initial',
        'top' : 'initial',
      });
    })

    $('#invest-modal').on('hidden.bs.modal', function () {
      $('body').css({
        'overflow' : 'initial',
        'position' : 'initial',
        'top' : 'initial',
      });
    })
*/


    jQuery('body').on('change', '#input_4_48', function() {
      console.log(jQuery('#input_4_48').val());
      jQuery('.amountcourse').text('$' + divededcourse().toFixed(2));
    });

    jQuery('body').on('change', '#input_4_53', function() {
      console.log(jQuery('#input_4_53').val());
      jQuery('.amountcourse').text('$' + divededcourse().toFixed(2));
    });

    function divededcourse() {
      var number1 = jQuery('#input_4_48').val().slice(0, -3).substring(1).split(',').join('');
      var number2 = jQuery('#input_4_53').val();

      if(number1 == '' ||  number2 == '') {
        return 0;
      }

      return number1 / number2
    }

    /*
    jQuery('#choice_4_42_1').change(function() {
      if(jQuery(this).is(':checked')) {
        jQuery('.totalsixpercen').css({
          'display' : 'block',
        });
      }  else {
        jQuery('.totalsixpercen').css({
          'display' : 'none',
        });
      }
    });
     */

    function showresult(total) {
      jQuery('.totalsixpercen').text('(Total one time donation: ' + total + ')');
    }

    jQuery('#input_4_8').click(function(){
      jQuery('#choice_4_2_0').click();
    });

    jQuery('#input_4_30').click(function(){
      jQuery('#choice_4_2_1').click();
    });

    jQuery('#input_4_48').click(function(){
      jQuery('#choice_4_2_2').click();
    });

    jQuery('#input_4_53').click(function(){
      jQuery('#choice_4_2_2').click();
    });

    jQuery('body').on('change', '#input_4_8', function() {
      var total = percentageonetime();
      showresult(total)
      // console.log(total);
    })

    jQuery('body').on('change', '#input_4_30', function() {
      var total = percentagemonthly();
      showresult(total)
      // console.log(total);
    })

    jQuery('body').on('change', '#input_4_48', function() {
      var total = percentagepledge();
      showresult(total)
      // console.log(total);
    })

    jQuery('body').on('change', '#input_4_53', function() {
      var total = percentagepledge();
      showresult(total)
      // console.log(total);
    })

    jQuery('#choice_4_2_0').change(function(){
      jQuery('#input_4_30').val('');
      jQuery('#input_4_48').val('');
      jQuery('#input_4_53').val('');
    });

    jQuery('#choice_4_2_1').change(function(){
      jQuery('#input_4_8').val('');
      jQuery('#input_4_48').val('');
      jQuery('#input_4_53').val('');
    });

    jQuery('#choice_4_2_2').change(function(){
      jQuery('#input_4_8').val('');
      jQuery('#input_4_30').val('');
    });

    function percentageonetime() {
      var donate = jQuery('#input_4_8').val().slice(0, -3).substring(1).split(',').join('');
      var sixpercentage = 0.06 * donate;
      var total = parseFloat(donate) + parseFloat(sixpercentage);

      return total.toFixed(2);
    }

    function percentagemonthly() {
      var donate = jQuery('#input_4_30').val().slice(0, -3).substring(1).split(',').join('');
      var sixpercentage = 0.06 * donate;
      var total = parseFloat(donate) + parseFloat(sixpercentage);

      return total.toFixed(2);
    }

    function percentagepledge() {
      var donate = divededcourse().toFixed(2);
      var sixpercentage = 0.06 * donate;
      var total = parseFloat(donate) + parseFloat(sixpercentage);

      return total.toFixed(2);
    }

    $('.ginput_product_price_label').text('Total monthly donation: ');
    $('#field_4_55 .ginput_product_price_label').text('Total one time donation: ');

    jQuery('#input_2_8').click(function(){
      jQuery('#choice_2_2_0').click();
    });
    jQuery('#input_2_30').click(function(){
      jQuery('#choice_2_2_1').click();
    });

    jQuery('#choice_2_2_0').click(function() {
      jQuery('#input_2_30').val('');
    });

    jQuery('#choice_2_2_1').click(function() {
      jQuery('#input_2_8').val('');
    });

    $('#validation_message_4_2').text('Donation field is required.');
    $('#validation_message_2_2').text('Donation field is required.');

    function ourImpactShow(hashStr) {
      var hash = hashStr ? hashStr : window.location.hash;

      console.log(hash)
      if(hash) {
        console.log($('#report-card').find(hash)) ;
        $('.nav-link').removeClass('active show');
        $('#myTabContent2 .tab-pane').removeClass('show active');
        $('#myTabContent .tab-pane').removeClass('show active');

        if($('#report-card').find(hash).length) {
          $('#report-card').addClass('active show');
          $('#report-card-tab').addClass('active show');
        } else {
          $('#our-school-district').addClass('active show');
          $('#our-school-district-tab').addClass('active show');
        }


        $(hash).addClass('active show');
        $(hash+'-tab').addClass('active show');
      } else {
        $('#report-card').addClass('active show');
        $('#report-card-tab').addClass('active show');
        $('#our-school-district').addClass('active show');
        $('#our-school-district-tab').addClass('active show');
      }
    }

    $(function() {
      ourImpactShow()
    });


    function accordionFAQ() {
      var accordionItem = $('#accor-filter .box-tile');
      var accordionItemlength = accordionItem.length;
      for( var i = 0 ; i < accordionItemlength; i++) {
        $('#data' + i).on('show.bs.collapse', function () {
          $('.box-tile').removeClass('active');
          $(this).siblings('.box-tile').addClass('active');
        })

        $('#data' + i).on('hide.bs.collapse', function () {
          $(this).siblings('.box-tile').removeClass('active');
        })
      }
    }
    accordionFAQ();

    $(document).ready(function(){
        $('.parallax-on').paroller();

      function set_min_height() {
        var $window = $(window);
        var windowsize = $window.width();


        $('.related-resources').each(function () {

          var $columns = $('.content-related', this);
          var maxHeight = Math.max.apply(Math, $columns.map(function () {
            return $(this).height();
          }).get());


          // Set the height of all those children to whichever was highest


          if (windowsize > 760) {
            $columns.height(maxHeight);
          } else {
            $columns.height('');
          }

        });

          $('.give-section ').each(function () {

              var $columns = $('.content-give-box ', this);
              var maxHeight = Math.max.apply(Math, $columns.map(function () {
                  return $(this).height();
              }).get());


              // Set the height of all those children to whichever was highest


              if (windowsize > 760) {
                  $columns.height(maxHeight);
              } else {
                  $columns.height('');
              }

          });

      }

      set_min_height();


      $(window).on('resize', function () {
        set_min_height();
      });


      $('.nav-link').click(function() {
        setTimeout(function() {
            if($('.tab-pane.active').length) {
                var url = '/our-impact/'
                if($('.tab-pane.active').length > 1) {
                    url += '#' + $('.tab-pane.active').eq(1).attr('id');
                } else {
                    url += '#' + $('.tab-pane.active').attr('id');
                }

                window.history.replaceState(
                    null,
                    'Our Impact',
                    url
                )
            }
        }, 200)
      })

        if($('.our-team').length == 0) {
            $('.navbar a[href*="/#"]').click(function (event) {
                var pathname = window.location.pathname;
                event.preventDefault();
                var url = jQuery(this).attr('href');
                var type = url.split('#');
                console.log(url);
                if (type[0].includes(pathname) && pathname !== '/') {
                    console.log(pathname);
                    if (type[0].includes('our-impact')) {
                        ourImpactShow('#' + type[1])
                        window.history.replaceState(
                            null,
                            'Our Impact',
                            url
                        )
                    }

                    if (type[0].includes('our-team')) {
                        ourImpactShow('#' + type[1])
                        window.history.replaceState(
                            null,
                            'Our Team',
                            url
                        )
                    }

                    console.log(type[1]);
                    $('html, body').animate({
                        scrollTop: $('#' + type[1]).offset().top,
                    }, 500);
                } else {
                    window.location.href = url;
                }

            });
        }
    });

      /**
       * initMap
       *
       * Renders a Google Map onto the selected jQuery element
       *
       * @date    22/10/19
       * @since   5.8.6
       *
       * @param   jQuery $el The jQuery element.
       * @return  object The map instance.
       */
      function initMap( $el ) {

          // Find marker elements within map.
          var $markers = $el.find('.marker');

          // Create gerenic map.
          var mapArgs = {
              zoom        : $el.data('zoom') || 8,
              mapTypeId   : google.maps.MapTypeId.ROADMAP
          };
          var map = new google.maps.Map( $el[0], mapArgs );

          // Add markers.
          map.markers = [];
          $markers.each(function(){
              initMarker( $(this), map );
          });

          // Center map based on markers.
          centerMap( map );

          // Return map instance.
          return map;
      }

      /**
       * initMarker
       *
       * Creates a marker for the given jQuery element and map.
       *
       * @date    22/10/19
       * @since   5.8.6
       *
       * @param   jQuery $el The jQuery element.
       * @param   object The map instance.
       * @return  object The marker instance.
       */
      function initMarker( $marker, map ) {

          // Get position from marker.
          var lat = $marker.data('lat');
          var lng = $marker.data('lng');
          var latLng = {
              lat: parseFloat( lat ),
              lng: parseFloat( lng )
          };

          // Create marker instance.
          var marker = new google.maps.Marker({
              position : latLng,
              map: map
          });

          // Append to reference for later use.
          map.markers.push( marker );

          // If marker contains HTML, add it to an infoWindow.
          if( $marker.html() ){

              // Create info window.
              var infowindow = new google.maps.InfoWindow({
                  content: $marker.html()
              });

              // Show info window when marker is clicked.
              google.maps.event.addListener(marker, 'click', function() {
                  infowindow.open( map, marker );
              });
          }
      }

      /**
       * centerMap
       *
       * Centers the map showing all markers in view.
       *
       * @date    22/10/19
       * @since   5.8.6
       *
       * @param   object The map instance.
       * @return  void
       */
      function centerMap( map ) {

          // Create map boundaries from all map markers.
          var bounds = new google.maps.LatLngBounds();
          map.markers.forEach(function( marker ){
              bounds.extend({
                  lat: marker.position.lat(),
                  lng: marker.position.lng()
              });
          });

          // Case: Single marker.
          if( map.markers.length == 1 ){
              map.setCenter( bounds.getCenter() );

              // Case: Multiple markers.
          } else{
              map.fitBounds( bounds );
          }
      }

// Render maps on page load.
      $(document).ready(function(){
          $('.acf-map').each(function(){
              var map = initMap( $(this) );
          });
      });

  },
};

if($('.home').length == 0){
    $('a:not(.download)').each(function() {
        var a = new RegExp('/' + window.location.host + '/');
        if(!a.test(this.href)) {
            $(this).click(function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
            });
        }
    });
}

var icsFile = null;
function createFile(data) {
    var eventDate = {
            start: data.attr('data-startdate'),
            end: data.attr('data-enddate')
        },
        titleEvent = data.attr('data-title');
    data.attr('href', makeIcsFile(eventDate,titleEvent));
}
function convertDate(date) {
    var event = new Date(date).toISOString();
    event = event.replaceAll("-", "");
    event = event.replaceAll(":", "");
    event = event.split(".")[0];
    return event;
}
function makeIcsFile(date,titleEvent) {
    var test =
        "BEGIN:VCALENDAR\n" +
        "CALSCALE:GREGORIAN\n" +
        "METHOD:PUBLISH\n" +
        "PRODID:-//Test Cal//EN\n" +
        "VERSION:2.0\n" +
        "BEGIN:VEVENT\n" +
        "UID:test-1\n" +
        "DTSTART;VALUE=DATE:" +
        convertDate(date.start) +
        "\n" +
        "DTEND;VALUE=DATE:" +
        convertDate(date.end) +
        "\n" +
        "SUMMARY:" +
        titleEvent +
        "\n" +
        "END:VEVENT\n" +
        "END:VCALENDAR";

    var data = new File([test], { type: "text/plain" });

    // If we are replacing a previously generated file we need to
    // manually revoke the object URL to avoid memory leaks.
    if (icsFile !== null) {
        window.URL.revokeObjectURL(icsFile);
    }

    icsFile = window.URL.createObjectURL(data);

    return icsFile;
}

$(function($) {
    $(document).ready(function() {
        $('.download').click(function() {
            createFile($(this))
        })
    })
})



// WEBPACK FOOTER //
// ./scripts/routes/common.js